<template>
    <div>
        <template>
            <kgr-button
                class="button_duplicate kgr-row"
                :disabled="elementsToDuplicate.length === 0 || kindergartenTarget === null || inProgress"
                :pending="inProgress"
                @click="duplicate()"
            >
                {{ $t('duplication.' + type + '.duplicate') }}
            </kgr-button>
            <table class="kgr-table kgr-table--striped kgr-table--block table-groups kgr-row">
                <thead>
                    <tr class="kgr-table__row">
                        <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--noGrow">
                            {{ $t('options') }}
                        </th>
                        <slot name="header"></slot>
                        <th class="kgr-table__cell kgr-table__cell--headline">
                            {{ $t('duplication.hints') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="element in filteredElements"
                        class="kgr-table__row"
                    >
                        <td class="kgr-table__cell">
                            <kgr-checkbox
                                :checked="selectedElements.indexOf(element) !== -1"
                                @change="toggleElement(element, $event)"
                            />
                        </td>
                        <slot
                            name="row"
                            :element="element"
                        ></slot>
                        <td class="kgr-table__cell">
                            <img
                                v-if="existsInTargetKindergarten(element)"
                                src="@img/info.png"
                                :title="$t('duplication.' + type + '.exists_in_target_kindergarten')"
                                style="display: block; margin: auto"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            <kgr-button
                class="button_duplicate"
                :disabled="elementsToDuplicate.length === 0 || kindergartenTarget === null || inProgress"
                :pending="inProgress"
                @click="duplicate()"
            >
                {{ $t('duplication.' + type + '.duplicate') }}
            </kgr-button>
        </template>
    </div>
</template>

<script>
import Checkbox from '../common/form/checkbox/Checkbox.vue';
import KgrButton from '../common/form/button/KgrButton';

export default {
    components: {
        'kgr-checkbox': Checkbox,
        'kgr-button': KgrButton,
    },
    props: {
        sourceElements: {
            type: Array,
            required: true,
        },
        targetElements: {
            type: Array,
            required: true,
        },
        kindergartenTarget: {
            type: Object,
            required: false,
            default: null,
        },
        filters: {
            type: Array,
            required: true,
        },
        inProgress: {
            type: Boolean,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        matchingFunction: {
            type: Function,
            required: true,
        }
    },
    data() {
        return {
            selectedElements: [],
        }
    },
    computed: {
        filteredElements() {
            return this.sourceElements.filter(element => this.matchingFunction(this.filters, element));
        },
        elementsToDuplicate() {
            return this.filteredElements.filter(element => this.selectedElements.indexOf(element) !== -1);
        },
    },
    methods: {
        duplicate() {
            this.$emit('duplicate', this.selectedElements);
            this.selectedElements = [];
        },
        toggleElement(element, selected) {
            if (selected) {
                this.selectedElements.push(element);
            } else {
                this.selectedElements.splice(this.selectedElements.indexOf(element), 1);
            }
        },
        existsInTargetKindergarten(element) {
            return this.targetElements
                .filter(c => element.firstName === c.firstName && element.lastName === c.lastName)
                .length > 0;
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .button_duplicate {
        display: block;
        margin-left: auto;
    }
</style>
